(function($){
    $(document).ready(function(){
        if($('#ct-ultimate-gdpr-cookie-modal').length > 0 && $('.cookie-sections').length <= 0){
            $('<div class="cookie-sections"></div>').insertBefore('.ct-ultimate-gdpr-cookie-modal-single');
            $('.ct-ultimate-gdpr-cookie-modal-single ul li').each(function(){
                var inpid = $(this).find('input').attr('id');
                var state = '', text = '';
                if($(this).find('input').prop('checked') == true){
                    state = 'active';
                }
                if(inpid == 'cookie0'){
                    text = $('.ct-ultimate-gdpr-cookie-modal-slider-able .block-all').html();
                }
                if(inpid == 'cookie5'){
                    text = $('.ct-ultimate-gdpr-cookie-modal-slider-able .essentials').html();
                }
                if(inpid == 'cookie6'){
                    text = $('.ct-ultimate-gdpr-cookie-modal-slider-able .functionality').html();
                }
                if(inpid == 'cookie7'){
                    text = $('.ct-ultimate-gdpr-cookie-modal-slider-able .analytics').html();
                }
                if(inpid == 'cookie8'){
                    text = $('.ct-ultimate-gdpr-cookie-modal-slider-able .advertising').html();
                }
                $('.cookie-sections').append('<div class="cookie-line" onclick="change_cookie_state(jQuery(this));"><div class="name"><h6>'+$(this).find('span').html()+'</h6><p>'+text+'</p></div><div class="switcher '+state+'" data-id="'+inpid+'"><span></span></div></div>');
            })
        }
    })

})(jQuery)
function change_cookie_state(th){
    // th.find('.switcher').toggleClass('active')
    jQuery('.ct-ultimate-gdpr-cookie-modal-single input[id="'+th.find('.switcher').attr('data-id')+'"]').click();
    setTimeout(function(){
        jQuery('.ct-ultimate-gdpr-cookie-modal-single ul li').each(function(){
            var inpid = jQuery(this).find('input').attr('id');
            if(jQuery(this).find('input').prop('checked') == true){
                jQuery('.cookie-sections .cookie-line .switcher[data-id="'+inpid+'"]').addClass('active');
            }
            else{
                jQuery('.cookie-sections .cookie-line .switcher[data-id="'+inpid+'"]').removeClass('active');
            }

        })
    }, 100)
}
document.body.addEventListener('click', function(event) {
    if (event.target.closest('.cookie-sections .cookie-line')) {
        event.preventDefault();
        alert('Kliknięto na cookie-line');
        event.target.closest('.cookie-sections .cookie-line').querySelector('.switcher').classList.toggle('active');
    }
});